<template>
	<div class="active-watchlist-selector q-pt-sm q-px-md row justify-between" v-if="watchlist && !virtualLog">
		<router-link :to="{ name: 'watchlistDetail', params: {id: watchlist.uid, watchlist: watchlist}}">{{ watchlist.name }}</router-link>
		<span v-if="watchlist.customerName">{{ watchlist.customerName }}</span>
		<span v-if="watchlist.totalArea">{{ watchlist.totalArea | area }}</span>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex';
	import NumberFormattingFilters from "@/mixins/NumberFormattingFilters";

	export default {
		name: "ActiveWatchlistSelector",
		mixins: [NumberFormattingFilters],
		computed: {
			...mapGetters(['watchlist', 'virtualLog'])
		}
	}
</script>

<style scoped>
	.active-watchlist-selector {
		width: 100%;
		max-width: 1590px;
		margin: 0 auto;
		height: 35px;
		background: #ffffff;
		color: var(--q-color-dark);
	}
</style>